import { createContext } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DEFAULT_FILTER_STATE, FilterState, ResourceV2, ViewMode } from '@/components/SchedulerComponents/types';

interface SchedulerV2ContextValue {
  viewMode: ViewMode;
  setViewMode: (v: ViewMode) => void;
  currentDate: Dayjs;
  setCurrentDate: (d: Dayjs) => void;
  filters: FilterState;
  setFilters: (f: FilterState) => void;
  filterBarOpen: boolean;
  setFilterBarOpen: (open: boolean) => void;
  activeFilterCount: number;
  selectedResource: ResourceV2 | null;
  setSelectedResource: (r: ResourceV2 | null) => void;
}

const SchedulerV2Context = createContext<SchedulerV2ContextValue>({
  viewMode: 'week',
  setViewMode: () => { },
  currentDate: dayjs(),
  setCurrentDate: () => { },
  filters: DEFAULT_FILTER_STATE,
  setFilters: () => { },
  filterBarOpen: false,
  setFilterBarOpen: () => { },
  activeFilterCount: 0,
  selectedResource: null,
  setSelectedResource: () => { },
});

export default SchedulerV2Context;
